export default __webpack_public_path__ + "static/media/ic_aio.ffe967fe.svg";